export default __webpack_public_path__ + "static/media/PotlatchLogo.4cdd47ac.svg";